module.exports = __webpack_public_path__ + "img/17.2-gallery.52ef9bb7.jpg";